import { render, staticRenderFns } from "./ModalNewsDetail.vue?vue&type=template&id=162060a4&scoped=true&"
import script from "./ModalNewsDetail.vue?vue&type=script&lang=js&"
export * from "./ModalNewsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModalNewsDetail.vue?vue&type=style&index=0&id=162060a4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162060a4",
  null
  
)

export default component.exports